import React, { FC } from 'react';
import NRDSVerifyMembershipModal, {
  NRDSVerifyMembershipModalProps,
} from './nrds-verify-membership-modal';

const BridgeVerifyMembershipModal: FC<NRDSVerifyMembershipModalProps> = (
  props
) => {
  const { account } = props;
  return (
    <NRDSVerifyMembershipModal
      {...props}
      onBeforeSubmit={({ nrdsId, lastName }) =>
        account.setBridgeRiApiCredentials(nrdsId, lastName)
      }
    />
  );
};

export default BridgeVerifyMembershipModal;
